import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import styled from "styled-components";

export const DropdownOptionWrapper = styled.div<{ selected?: boolean }>`
  cursor: pointer;
  display: flex;
  font-size: 12px;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: ${(props) =>
    props.selected ? Core.surface.subdued : "transparent"};
  outline: 0;
  border: 0;
  padding: 0px 10px;

  &:hover {
    background-color: ${Core.surface.subdued};
  }
`;

export const OptionName = styled(Typography).attrs({
  truncate: true,
})`
  width: 120px;
  flex: none;
`;

export const ActionModalContent = styled(Column)`
  padding: ${getSpacing("3x")};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("5x")};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing("7x")};
  }
`;
